// Environment configuration for the frontend
const config = {
  // API Configuration
  API_URL: process.env.REACT_APP_API_URL || '',
  
  // Vetscribe Configuration
  VETSCRIBE_URL: process.env.REACT_APP_VETSCRIBE_URL || 'http://localhost:3001',
  
  // Google Maps Configuration
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  
  // Environment mode (deployed or development)
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || 'development',
  
  // Development mode
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  
  // Production mode
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
  
  // Helper functions
  isDeployed: () => {
    return (process.env.REACT_APP_ENVIRONMENT || 'development').toLowerCase() === 'deployed';
  },
  
  isDevelopment: () => {
    return (process.env.REACT_APP_ENVIRONMENT || 'development').toLowerCase() === 'development';
  },
};

// Validation (development only)
if (!config.GOOGLE_MAPS_API_KEY && config.IS_DEVELOPMENT) {
  console.warn('GOOGLE_MAPS_API_KEY not found in environment variables');
}

export default config;
